<template>
  <div class="tab-content">

    <el-tabs :value="value" @input="(val) => $emit('input', val)" @tab-click="handleClick">

      <!-- selling -->
      <el-tab-pane :disabled="!projectPermission.viewCRMSelling" v-if="selectedRow.type === 'project'" :label="$t('project_tab_crm_selling')" name="sellingProject">

          <el-tabs>
            <el-tab-pane :disabled="!projectPermission.createCRMSellingEstimate" :label="$t('project_tab_crm_selling_estimate')" name="estimateProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createCRMSellingQuotation" :label="$t('project_tab_crm_selling_quotation')" name="quotationProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createCRMSellingSalesOrder " :label="$t('project_tab_crm_selling_salesOrder')" name="salesOrderProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createCRMSellingSalesPosting" :label="$t('project_tab_crm_selling_salesPosting')" name="salesPostingProject">
              Current Service Under Development
            </el-tab-pane>
          </el-tabs>

      </el-tab-pane>
      <el-tab-pane :disabled="!projectPermission.viewTaskCRMSelling" v-else :label="$t('project_tab_crm_selling')" name="sellingTask">

          <el-tabs>
            <el-tab-pane :disabled="!projectPermission.createTaskCRMSellingEstimate" :label="$t('project_tab_crm_selling_estimate')" name="estimateTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createTaskCRMSellingQuotation" :label="$t('project_tab_crm_selling_quotation')" name="quotationTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createTaskCRMSellingSalesOrder " :label="$t('project_tab_crm_selling_salesOrder')" name="salesOrderTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createTaskCRMSellingSalesPosting" :label="$t('project_tab_crm_selling_salesPosting')" name="salesPostingTask">
              Current Service Under Development
            </el-tab-pane>
          </el-tabs>

      </el-tab-pane>

      <!-- delivering -->
      <el-tab-pane :disabled="!projectPermission.viewCRMDelivering" v-if="selectedRow.type === 'project'" :label="$t('project_tab_crm_delivering')" name="deliveringProject">

          <el-tabs>
            <el-tab-pane :disabled="!projectPermission.createCRMDeliveringDeliveryOrder" :label="$t('project_tab_crm_delivering_deliveryOrder')" name="deliveryOrderProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createCRMDeliveringPackingList" :label="$t('project_tab_crm_delivering_packingList')" name="packingListProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createCRMDeliveringDeliveryReciept" :label="$t('project_tab_crm_delivering_deliveryReciept')" name="deliveryRecieptProject">
              Current Service Under Development
            </el-tab-pane>
          </el-tabs>

      </el-tab-pane>
      <el-tab-pane :disabled="!projectPermission.viewTaskCRMDelivering" v-else :label="$t('project_tab_crm_delivering')" name="deliveringTask">

          <el-tabs>
            <el-tab-pane :disabled="!projectPermission.createTaskCRMDeliveringDeliveryOrder" :label="$t('project_tab_crm_delivering_deliveryOrder')" name="deliveryOrderTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createTaskCRMDeliveringPackingList" :label="$t('project_tab_crm_delivering_packingList')" name="packingListTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createTaskCRMDeliveringDeliveryReciept" :label="$t('project_tab_crm_delivering_deliveryReciept')" name="deliveryRecieptTask">
              Current Service Under Development
            </el-tab-pane>
          </el-tabs>

      </el-tab-pane>

      <!-- managing -->
      <el-tab-pane :disabled="!projectPermission.viewCRMManaging" v-if="selectedRow.type === 'project'" :label="$t('project_tab_crm_managing')" name="managingProject">

          <el-tabs>
            <el-tab-pane :disabled="!projectPermission.createCRMManagingSalesInvoice" :label="$t('project_tab_crm_managing_salesInvoice')" name="salesInvoiceProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createCRMManagingClientPayment" :label="$t('project_tab_crm_managing_clientPayment')" name="clientPaymentProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createCRMManagingClientReturns" :label="$t('project_tab_crm_managing_clientReturns')" name="clientReturnsProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createCRMManagingReminders" :label="$t('project_tab_crm_managing_reminders')" name="remindersProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createCRMManagingFinanceCharges" :label="$t('project_tab_crm_managing_financeCharges')" name="financeChargesProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createCRMManagingSalesCredits" :label="$t('project_tab_crm_managing_salesCredits')" name="salesCreditsProject">
              Current Service Under Development
            </el-tab-pane>
          </el-tabs>

      </el-tab-pane>
      <el-tab-pane :disabled="!projectPermission.viewTaskCRMManaging" v-else :label="$t('project_tab_crm_managing')" name="managingTask">

          <el-tabs>
            <el-tab-pane :disabled="!projectPermission.createTaskCRMManagingSalesInvoice" :label="$t('project_tab_crm_managing_salesInvoice')" name="salesInvoiceTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createTaskCRMManagingClientPayment" :label="$t('project_tab_crm_managing_clientPayment')" name="clientPaymentTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createTaskCRMManagingClientReturns" :label="$t('project_tab_crm_managing_clientReturns')" name="clientReturnsTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createTaskCRMManagingReminders" :label="$t('project_tab_crm_managing_reminders')" name="remindersTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createTaskCRMManagingFinanceCharges" :label="$t('project_tab_crm_managing_financeCharges')" name="financeChargesTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createTaskCRMManagingSalesCredits" :label="$t('project_tab_crm_managing_salesCredits')" name="salesCreditsTask">
              Current Service Under Development
            </el-tab-pane>
          </el-tabs>

      </el-tab-pane>

      <!-- estimate -->
      <!-- <el-tab-pane v-if="selectedRow.type === 'project'" label="Estimate" name="estimateProject">
          Current Service Under Development
          (Estimate project)
      </el-tab-pane>
      <el-tab-pane v-else label="Estimate" name="estimateTask">
          Current Service Under Development
          (Estimate)
      </el-tab-pane> -->

      <!-- quotation -->
      <!-- <el-tab-pane v-if="selectedRow.type === 'project'" label="Quotation" name="quotationProject">
          Current Service Under Development
          (Quotation project)
      </el-tab-pane>
      <el-tab-pane v-else label="Quotation" name="quotationTask">
          Current Service Under Development
          (Quotation)
      </el-tab-pane> -->

      <!-- sales order -->
      <!-- <el-tab-pane v-if="selectedRow.type === 'project'" label="Sales Order" name="salesOrderProject">
          Current Service Under Development
          (Sales Order project)
      </el-tab-pane>
      <el-tab-pane v-else label="Sales Order" name="salesOrderTask">
          Current Service Under Development
          (Sales Order)
      </el-tab-pane> -->

      <!-- invoice -->
      <!-- <el-tab-pane v-if="selectedRow.type === 'project'" label="Invoice" name="invoiceProject">
          Current Service Under Development
          (Invoice project)
      </el-tab-pane>
      <el-tab-pane v-else label="Invoice" name="invoiceTask">
          Current Service Under Development
          (Invoice)
      </el-tab-pane> -->

    </el-tabs>

    <!-- bookmark -->
<!--    <div class="book-mark-block pointer" v-if="bookmarkList">-->
<!--      <div v-if="selectedRow.type === 'project'">-->
<!--        <div v-if="bookmarkListProject.crm" @click="changeBookMarkProject(bookmarkListProject.crm, $route.query.companyId, selectedRow.projectId)"><img src="@/assets/img/bookmark/bm_act.svg"></div>-->
<!--        <div v-else @click="changeBookMarkProject(bookmarkListProject.crm, $route.query.companyId, selectedRow.projectId)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>-->
<!--      </div>-->

<!--      <div v-else>-->
<!--        <div v-if="bookmarkList.crm" @click="changeBookMark(bookmarkList.crm, $route.query.companyId, selectedRow.projectId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_act.svg"></div>-->
<!--        <div v-else @click="changeBookMark(bookmarkList.crm, $route.query.companyId, selectedRow.projectId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>-->
<!--      </div>-->
<!--    </div>-->

  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'

  export default {
    components: {

    },
    props: [
      'isProject',
      'selectedRow',
      'value',
      'bookmarkList',
      'bookmarkListProject',
      'projectPermission'
    ],
    data() {
      return {
        activeStar: 'el-icon-star-on',
        notActiveStar: 'el-icon-star-off',
      }
    },
    methods: {
      handleClick(tab, event, projectTaskId) {
        // estimate
        if(tab.label === "Estimate" && tab.name == "estimateProject" && this.isProject){
          // dispatch
        }
        if(tab.label === "Estimate" && tab.name == "estimateTask" && !this.isProject){
          // dispatch
        }

        // quotation
        if(tab.label === "Quotation" && tab.name == "quotationProject" && this.isProject){
          // dispatch
        }
        if(tab.label === "Quotation" && tab.name == "quotationTask" && !this.isProject){
          // dispatch
        }

        // sales order
        if(tab.label === "Sales Order" && tab.name == "salesOrderProject" && this.isProject){
          // dispatch
        }
        if(tab.label === "Sales Order" && tab.name == "salesOrderTask" && !this.isProject){
          // dispatch
        }

        // invoice
        if(tab.label === "Invoice" && tab.name == "invoiceProject" && this.isProject){
          // dispatch
        }
        if(tab.label === "Invoice" && tab.name == "invoiceTask" && !this.isProject){
          // dispatch
        }
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      changeBookMark(state, companyid, projectId, taskId){
        let data = this.bookmarkList
        data.crm = !this.bookmarkList.crm
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/bookmarks/setProjectTask?companyId=${companyid}&projectId=${projectId}&projectTaskId=${taskId}`, data)
          .then(response => {
            if (this.bookmarkList.crm) {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
            } else {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
            }
          })
          .catch(error => {
          });
      },
      changeBookMarkProject(state, companyId, projectId, taskId){
        let data = this.bookmarkListProject
        data.crm = !this.bookmarkListProject.crm
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/bookmarks/setProject?companyId=${companyId}&projectId=${projectId}`, data)
          .then(response => {
            if (this.bookmarkListProject.crm) {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
            } else {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
            }
          })
          .catch(error => {
          });
      },
    }
  }
</script>

<style lang="scss" scoped>
// [ Modal ] end
.tab-content{
  position:relative;
  .book-mark-block{
    position:absolute;
    top:0;
    right:0;
    .el-checkbox__input{
      display:none;
    }
    .el-checkbox {
      border: none;
    }
    .el-checkbox__label{
      font-size:20px !important;
      color: #409EFF;
    }
  }
}
</style>
